// External dependencies.
import swal from "sweetalert";
import apiFetch from "@wordpress/api-fetch";
import { __ } from "@wordpress/i18n";

/**
 * Class used to handle the contest form front-end.
 *
 * @since 1.7.1
 * @class ContestForm
 */
class ContestForm {
    /**
     * Creates an instance of ContestForm.
     * 
     * @since 1.7.1
     * @memberof ContestForm
     */
    constructor() {
        this.formElement = document.querySelector( '.js-contest-form' );
        this.submitElement = ( this.formElement ) ? this.formElement.querySelector( 'button[type="submit"]' ) : null;

        this.events = this.events.bind( this );
        this.resetSubmitElement = this.resetSubmitElement.bind( this );
        this.sendForm = this.sendForm.bind( this );
        this.handleSuccess = this.handleSuccess.bind( this );
        this.handleError = this.handleError.bind( this );

        this.events();
    }

    /**
     * Listens for events.
     *
     * @since 1.7.1
     * @listens .js-wholesale-form~event:submit
     * @memberof ContestForm
     */
    events() {
        this.formElement && this.formElement.addEventListener( 'submit', this.sendForm );
    }

    /**
     * Resets the submit element to its original state.
     *
     * @since 1.7.1
     * @memberof ContestForm
     */
    resetSubmitElement() {
        this.submitElement.removeAttribute( 'disabled' );
    }

    /**
     * Send the form.
     *
     * @since 1.7.1
     * @param {object} e
     * @memberof ContestForm
     */
    async sendForm( e ) {
        e.preventDefault();

        const url = this.formElement.getAttribute( 'action' );
        const body = new FormData( this.formElement );
        const method = 'POST';

        this.submitElement.setAttribute( 'disabled', true );

        try {
            await apiFetch( { url, body, method } );
            this.handleSuccess();
        } catch ( error ) {
            this.handleError( error );
        }
    }

    /**
     * Handles the form's success action.
     *
     * @since 1.7.1
     * @param {object} res
     * @memberof ContestForm
     */
    handleSuccess() {
        const { name } = window.app;
        // const text = res.data.message;
        const text = __( '¡Listo! Ya estás participando', 'tio-simon-foods' );
        this.resetSubmitElement();
        this.formElement.reset();

        swal( {
            title: name,
            text,
            icon: 'success',
            buttons: {
                confirm: {
                    text: __( 'Aceptar', 'tio-simon-foods' ),
                    className: 'btn btn-ts-primary',
                }
            }
        } );
    }

    /**
     * Handles the form's error action.
     *
     * @since 1.7.1
     * @param {object} error
     * @memberof ContestForm
     */
    handleError( error ) {
        console.log( error );
        this.resetSubmitElement();
        const { name } = window.app;
        let content = '';

        if ( error.data ) {
            if ( 'object' === typeof error.data ) {
                for ( const key in error.data ) {
                    if ( error.data.hasOwnProperty( key ) ) {
                        const element = error.data[ key ];
                        content += `${element}<br>`;
                    }
                }
            } else {
                content = error.data;
            }
        } else {
            content = __( 'Ha ocurrido un error procesando tu petición. Por favor actualiza la página e intenta nuevamente.', 'tio-simon-foods' );
        }

        const divElement = document.createElement( 'div' );
        divElement.innerHTML = content;

        swal( {
            title: name,
            content: divElement,
            icon: 'error',
            buttons: {
                confirm: {
                    text: __( 'Aceptar', 'tio-simon-foods' ),
                    className: 'btn btn-ts-primary'
                }
            }
        } ).then( () => divElement.remove() );
    }
}

export default ContestForm;
